export default __webpack_public_path__ + "static/toggl-global-main-a5157eb74a0c3256609ff8ce7e07ebcc.jpg";